import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0657ce4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "text mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportLineChart = _resolveComponent("ReportLineChart")!
  const _component_ReportBarChart = _resolveComponent("ReportBarChart")!
  const _component_ReportPieChart = _resolveComponent("ReportPieChart")!
  const _component_ReportBubbleChart = _resolveComponent("ReportBubbleChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.chart.title), 1),
    (_ctx.isLineChart)
      ? (_openBlock(), _createBlock(_component_ReportLineChart, {
          key: 0,
          chart: _ctx.chart,
          chartData: _ctx.chartData,
          class: "chart-view"
        }, null, 8, ["chart", "chartData"]))
      : _createCommentVNode("", true),
    (_ctx.isBarChart)
      ? (_openBlock(), _createBlock(_component_ReportBarChart, {
          key: 1,
          chart: _ctx.chart,
          chartData: _ctx.chartData,
          class: "chart-view"
        }, null, 8, ["chart", "chartData"]))
      : _createCommentVNode("", true),
    (_ctx.isPieChart)
      ? (_openBlock(), _createBlock(_component_ReportPieChart, {
          key: 2,
          chart: _ctx.chart,
          chartData: _ctx.chartData,
          class: "chart-view"
        }, null, 8, ["chart", "chartData"]))
      : _createCommentVNode("", true),
    (_ctx.isBubbleChart)
      ? (_openBlock(), _createBlock(_component_ReportBubbleChart, {
          key: 3,
          chart: _ctx.chart,
          chartData: _ctx.bubbleChartData,
          class: "chart-view"
        }, null, 8, ["chart", "chartData"]))
      : _createCommentVNode("", true)
  ]))
}